export type TwoFactorType = 'EMAIL' | 'SMS' | 'TOTP';

export interface TwoFactorLoginModel {
  type: TwoFactorType;
  account: string;
}

export interface  TwoFactorFormModel {
  code: string;
}

export const isTwoFactorLoginModel = (value: unknown): value is TwoFactorLoginModel =>
  value && typeof value === 'object' && 'type' in value && 'account' in value;

